import { render, staticRenderFns } from "./developApp.vue?vue&type=template&id=1b28eb84&scoped=true"
import script from "./developApp.vue?vue&type=script&lang=js"
export * from "./developApp.vue?vue&type=script&lang=js"
import style0 from "./developApp.vue?vue&type=style&index=0&id=1b28eb84&prod&lang=scss&scoped=true"
import style1 from "./developApp.vue?vue&type=style&index=1&id=1b28eb84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b28eb84",
  null
  
)

export default component.exports